<template>
	<div id="add-cancellation" v-if="editedItem" class="grid">
		<div class="grid-title">
			<h4>{{ $t("CANCELLATION_POLICY") }}</h4>
		</div>

		<div class="grid-body p-3 pb-0 border-top-unset">
			<v-form ref="form" lazy-validation v-on:submit.prevent>
				<v-row>
					<v-col sm="12">
						<label>{{ $t("POLICY_NAME") }} *</label>
						<v-text-field 
							v-model="editedItem.nameVi"
							:rules="[rules.required]"
							outlined
							dense
						>
						</v-text-field>
					</v-col>

					<v-col sm="12" class="pt-0">
						<label>{{ $t("DESCRIPTION") }}</label>
						<v-text-field
							outlined
							dense
							v-model="editedItem.descriptionVi"
							@keydown="handleMaxLength($event, 3000)"
							@paste="handleMaxLength($event, 3000)"
						>
						</v-text-field>
						<div class="d-flex justify-content-end text-secondary">{{ charCount(editedItem.descriptionVi, 3000) }}</div>
					</v-col>

					<v-col md="12" class="pt-0">
						<label>{{ $t("FREE_CANCELLATION_ALLOWED") }}</label>
						<v-radio-group row v-model="cancelRequired" class="mt-2">
							<v-radio color="indigo darken-3" :label="$t('YES')" :value="true"></v-radio>
							<v-radio color="indigo darken-3" :label="$t('NO')" :value="false"></v-radio>
						</v-radio-group>
						<p class="border-bottom pt-3"></p>
					</v-col>

					<v-col md="12" class="pt-0">
						<p><strong>{{$t('CONDITIONS')}}</strong></p>
						<div>
							<template v-if="cancelRequired === true">
								<div>
									<label>{{ $t("HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE") }}</label>
									<v-row>
										<v-col md="4">
											<v-select
												:items="select.cancelDayOption"
												item-text="text"
												item-value="value"
												v-model="cancelDaySelect"
												outlined
												dense
												class="text"
												:rules="[rules.select]"
											></v-select>
										</v-col>
										<v-col>
											<vuetify-number
												v-model="editedItem.cancellationDay"
												:options="amountOptionsVi"
												dense
												:rules="[rules.required, rules.number]"
												outlined
												v-if="[-2].includes(cancelDaySelect)"
											/>
										</v-col>
										<v-col class="align-midle" v-if="[-2].includes(cancelDaySelect)">
											<span>{{$t('DAY')}}</span>
										</v-col>
									</v-row>
								</div>
							</template>
							<template >
								<div>
									<label>{{ editedItem.cancellationDay === 0 ? $t("HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN") : editedItem.cancellationDay !== -1 ? $t("HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL" , {day: editedItem.cancellationDay}) : $t( "HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION") }}</label>
									<v-row>
										<v-col>
											<v-select
												:items="select.unit"
												item-text="text"
												item-value="value"
												v-model="editedItem.chargeType"
												outlined
												dense
												class="text"
												:rules="[rules.select]"
												@change="changeRuleAmount()"
											></v-select>
										</v-col>
										<v-col>
											<vuetify-number
												v-model="editedItem.amount"
												:options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn"
												dense
												:rules="[rules.required, rules.maxNight, rules.number]"
												outlined
												v-if="editedItem.chargeType == 2"
											/>
											<vuetify-number
												v-model="editedItem.amount"
												:options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn"
												dense
												:rules="[rules.required, rules.maxPercent, rules.number]"
												outlined
												v-if="editedItem.chargeType == 1"
											/>
											<v-text-field
												v-model="pricePolicy"
                                            	ref="pricePolicy"
												:options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn"
												dense
												:rules="[rules.required, rules.number]"
												outlined
												v-if="editedItem.chargeType == 0"
												@keydown="keyCurrencyDown($event, usedCurrency)"
                                            	:key="`pricePolicy_${forceRenderKey}`"
											/>
										</v-col>
										<v-col class="align-midle">
											<span>{{$t(editedItem.chargeType === 1 ? 'PERCENT_OF_TOTAL_ROOM_RATE' : editedItem.chargeType === 0 ? usedCurrency : 'NIGHT')}}</span>
										</v-col>
									</v-row>
								</div>
							</template>
						</div>
					</v-col>

					<v-col md="12" class="pt-0 pb-0">
						<v-row>
							<v-col md="6">
								<label>{{ $t("WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD") }}</label>
								<v-row>
									<v-col md="12" class="pt-0">
										<v-radio-group row v-model="editedItem.bookingSession" class="mt-2">
											<v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
											<v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col md="12" class="pt-0 date-picker">
										<v-row>
											<v-col sm="5" class="py-0">
												<label class="mb-0">{{ $t("FROM_DATE") }}</label>
												<date-picker
													:model.sync="editedItem.startBookingDate"
													:disabled="!editedItem.bookingSession"
													:min="currentDatePicker"
													:error.sync="error.startBookingDate.error"
												/>
											</v-col>
											<v-col sm="5" class="py-0">
												<label class="mb-0">{{ $t("TO_DATE") }}</label>
												<date-picker
													:model.sync="editedItem.endBookingDate"
													:min="editedItem.startBookingDate"
													:disabled="!editedItem.bookingSession"
													:error.sync="error.endBookingDate.error"
												/>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<v-col>
								<label>{{ $t("WHAT_DOES_CANCEL_POLICY_APPLY") }}</label>
								<v-row>
									<v-col md="12" class="pt-0">
										<v-radio-group row v-model="editedItem.stayingSession" class="mt-2">
											<v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
											<v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col md="12" class="pt-0 date-picker">
										<v-row>
											<v-col sm="5" class="py-0">
												<label class="mb-0">{{ $t("FROM_DATE") }}</label>
												<date-picker
													:model.sync="editedItem.startStayingDate"
													:disabled="!editedItem.stayingSession"
													:min="currentDatePicker"
													:error.sync="error.startStayingDate.error"
												/>
											</v-col>
											<v-col sm="5" class="py-0">
												<label class="mb-0">{{ $t("TO_DATE") }}</label>
												<date-picker
													:model.sync="editedItem.endStayingDate"
													:min="editedItem.startStayingDate"
													:disabled="!editedItem.stayingSession"
													:error.sync="error.endStayingDate.error"
												/>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
						<p class="border-bottom pt-3"></p>
					</v-col>
					<v-col md="12">
						<v-tabs v-model="tab" class="pl-0">
							<v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
						</v-tabs>
						<v-tabs-items v-model="tab">
							<v-tab-item v-for="code in codeLangs" :key="code">
								<v-row>
									<v-col sm="12" class="pb-0">
										<label class="label-input">{{ $t("POLICY_SUMMARY") }}</label>
										<v-textarea v-model="editedItem.cancellationI18n.find(x => x.lang == code).description" outlined
										:rows="6"
										counter="3000"
										maxlength="3000"
										class="input-counter"
										:rules="ruleDescNotRequired"
										dense></v-textarea>
									</v-col>
								</v-row>
							</v-tab-item>
						</v-tabs-items>
					</v-col>
				</v-row>
			</v-form>
			<hr>
			<div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
				<label class="text-nowrap mr-2">{{
				$t("CHANNEL_APPLY")
				}}</label>
				<v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
				v-model="selectedOTAGlobalAndCtrip" chips multiple style="width: 270px;" disabled>
				<template v-slot:selection="{ item, index }">
					<v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
					<span>{{ item.text }}</span>
					</v-chip>
				</template>
				</v-autocomplete>
			</div>
			<v-row>
				<v-col sm="12" class="pt-0">
					<div class="btn-bottom mt-5">
						<v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
						<v-btn color="primary" class="pl-10 pr-10" @click="save">{{ $t("SAVE") }}</v-btn>
					</div>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
import DatePicker from "@/components/Utils/DatePicker.vue";

import { _alert } from "@/_helpers/function.js";
import { service } from "@/_services/HotelSetting/cancellation-payment.service.js";
import moment from "moment";

export default {
	components: {
		"date-picker": DatePicker,
	},
	data() {
		return {
			sysLang: this.$i18n.locale || "vi",
			amountOptionsVi: {
				locale: "vi",
				length: 9,
				precision: 0
			},
			amountOptionsEn: {
				locale: "vi",
				length: 9,
				precision: 2
			},
			currentDatePicker: moment()
				.startOf("day")
				.format("YYYY-MM-DD"),
			rules: {
				required: value => !!value || this.$t("_REGISTER.REQUIRED_FIELD"),
				number: value => parseFloat(value) >= 0 || this.$t("DATA_INPUT_MUST_BE_GREATER_THAN_0"),
				select: value => value != null || this.$t("_REGISTER.REQUIRED_FIELD"),
				maxPercent: value => value <= 100 || this.$t("DATA_INPUT_MAX_100_PERCENT"),
				maxNight: value => value <= 10 || this.$t("DATA_INPUT_MAX_10_NIGHT"),
			},
			editedItem: {
				cancellationDay: 1,
			},
			select: {
				unit: [{ value: 2, text: this.$t("PRICE_PER_NIGHT") }, { value: 1, text: this.$t("PERCENT_BOOKING") }, { value: 0, text: this.$t('_BOOKING_DETAIL.SERVICE.COST') }],
				cancelDayOption: [
					{ value: 0, text: this.$t("BEFORE_CHECKIN_DATE")},
					{ value: 1, text: this.$t("DAY_BEFORE_CHECK_IN", {day: 1}) }, 
					{ value: 2, text: this.$t("DAY_BEFORE_CHECK_IN", {day: 2}) }, 
					{ value: 3, text: this.$t("DAY_BEFORE_CHECK_IN", {day: 3}) },
					{ value: 7, text: this.$t("DAY_BEFORE_CHECK_IN", {day: 7}) }, 
					{ value: -2, text: this.$t("ACCORDING_TO_CUSTOM") }, 
				]
			},
			error : {
				startStayingDate: { error: null, message: this.$t("_REGISTER.REQUIRED_FIELD"), required: true },
				endStayingDate: { error: null, message: this.$t("_REGISTER.REQUIRED_FIELD"), required: true },
				startBookingDate: { error: null, message: this.$t("_REGISTER.REQUIRED_FIELD"), required: null },
				endBookingDate: { error: null, message: this.$t("_REGISTER.REQUIRED_FIELD"), required: null },
			},
			cancelRequired: true,
			cancelDaySelect: 0,
			policySummary: [],
			tab: null,
			languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      		codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
			oldEditedItem: {},
			timeout: null,
            forceRenderKey: 0,
		};
	},
	async created() {
		this.codeLangs.forEach(e => {
			this.policySummary.push({
				description: null,
				lang: e,
				name: null,
			})
		});
		this.currency = this.priceOptionsVi.suffix;
		let id = this.$route.params.id;
		if (id != 0) {
			let params = {
				limit: 0,
				offset: 0
			};
			await service.get(params).then(res => {
				params = {
					limit: res.total,
					offset: 0
				};
			});
			await service.get(params).then(res => {
				this.editedItem = Object.assign({}, res.data.find(x => x.id == id));
				this.editedItem.cancellationI18n.forEach(e => {
                    e.description = e.description.replace(/[\n\t]/g, " ");
                    e.description = e.description.replace(/\s+/g, " ");
                });
				this.oldEditedItem = JSON.parse(JSON.stringify(this.editedItem));
				this.cancelRequired = this.editedItem.cancellationDay !== -1;
				this.cancelDaySelect = [0, 1, 2, 3, 7].includes(this.editedItem.cancellationDay) ? this.editedItem.cancellationDay : -2;
			});
		} else {
			this.editedItem = {
				amount: 0,
				cancellationDay: 0,
				chargeType: 1,
				bookingSession: false,
				descriptionVi: null,
				endBookingDate: null,
				endStayingDate: null,
				startBookingDate: null,
				startStayingDate: null,
				stayingSession: false,
				cancellationI18n: [...this.policySummary]
			};
		}
	},
	mounted() {
		document
			.querySelector(".v-tab.v-tab--active")
			.classList.remove("v-tab--active");
		document
			.querySelector(".v-tab[tabIndex='2']")
			.classList.add("v-tab--active");
	},
	watch: {
		editedItem: {
			handler(value) {
				if (new Date(value.startBookingDate).getTime() > new Date(value.endBookingDate).getTime()) {
					value.endBookingDate = '';
				}
				if (new Date(value.startStayingDate).getTime() > new Date(value.endStayingDate).getTime()) {
					value.endStayingDate = '';
				}
				 if (value.chargeType == 2 || value.chargeType == 1) {
                    this.amountOptionsEn.precision = 0;
                    if (value.chargeType == 1) {
                        this.amountOptionsEn.length = 3;
                        this.amountOptionsVi.length = 3;
                    } else if (value.chargeType == 2) {
                        this.amountOptionsEn.length = 2;
                        this.amountOptionsVi.length = 2;
                    }
                } else {
                    this.amountOptionsEn.precision = 2;
                    this.amountOptionsVi.length = 9;
                    this.amountOptionsEn.length = 6;
                }
				let textCancelVi = '';
				let textCancelDefault = '';
				if (+value.cancellationDay === 0) {
					if (+value.amount === 0) {
						textCancelVi = `Khách hàng được hủy đặt phòng miễn phí.`;
						textCancelDefault = `Customers can cancel their reservation for free.`;
					} else {
						textCancelVi = `Khách hàng được hủy đặt phòng miễn phí trước ngày đến, nếu hủy đặt phòng trong ngày đến khách hàng sẽ phải chịu phí hủy là ${value.chargeType === 1 ? value.amount + '% giá trị đặt phòng' : value.chargeType === 0 ? this.numberFormat(value.amount, "VND") + ' ' + this.usedCurrency : value.amount + ' đêm'}.`;
						textCancelDefault = `Guests can cancel their reservation free of charge prior to arrival date, if you cancel your reservation on the day of arrival, you will be charged a cancellation fee of ${value.chargeType === 1 ? value.amount + '% of booking value' : value.chargeType === 0 ? this.numberFormat(value.amount, "USD") + ' ' + this.usedCurrency : value.amount + ' night'}.`;
					}
				} else if (+value.cancellationDay === -1) {
					if (+value.amount !== 0) {
						textCancelVi = `Khách hàng sẽ phải chịu phí 
										${value.chargeType === 1 ? value.amount + '% giá trị đặt phòng' : value.chargeType === 0 ? this.numberFormat(value.amount, "VND") + ' ' + this.usedCurrency : value.amount + ' đêm'}
										nếu hủy đặt phòng.`;
						textCancelDefault = `Customer will be charged
										${value.chargeType === 1 ? value.amount + '% of booking value' : value.chargeType === 0 ? this.numberFormat(value.amount, "USD") + ' ' + this.usedCurrency  : value.amount + ' night'}
										if the reservation is canceled.`;
					} else {
						textCancelVi = `Khách hàng được hủy đặt phòng miễn phí.`;
						textCancelDefault = `Customers can cancel their reservation for free.`;
					}
				} else {
					if (+value.amount !== 0) {
						textCancelVi = `Khách hàng được hủy miễn phí nếu hủy trước ${value.cancellationDay} ngày trước khi tới nhận phòng, nếu hủy đặt phòng trong vòng ${value.cancellationDay} ngày trước khi tới nhận phòng khách hàng sẽ phải chịu phí hủy là ${value.chargeType === 1 ? value.amount + '% giá trị đặt phòng' : value.chargeType === 0 ? this.numberFormat(value.amount, "VND") + ' ' + this.usedCurrency : value.amount + ' đêm'}.`;
						textCancelDefault = `Free cancellation if you cancel ${value.cancellationDay} days before check-in, if you cancel your reservation within ${value.cancellationDay} days before check-in, you will be charged a cancellation fee. to be ${value.chargeType === 1 ? value.amount + '% of booking value' : value.chargeType === 0 ? this.numberFormat(value.amount, "USD") + ' ' + this.usedCurrency : value.amount + ' night'}.`;
					} else {
						textCancelVi = `Khách hàng được hủy đặt phòng miễn phí.`;
						textCancelDefault = `Customers can cancel their reservation for free.`;
					}
				}
				if (this.editedItem.cancellationI18n.length > 0) {
					this.editedItem.cancellationI18n.forEach(item => {
						if (!item.description) {
							this.codeLangs.forEach(e => {
								this.policySummary.forEach(ele => {
									if (e === 'vi' && e === ele.lang) {
										ele.description = textCancelVi;
										ele.name = value.nameVi
									} else {
										if(e === ele.lang) {
											ele.description = textCancelDefault;
											ele.name = value.nameVi
										}
									}
								});
							});
						}
					});
				}
				if (this.oldEditedItem.amount !== value.amount || this.oldEditedItem.cancellationDay !== value.cancellationDay || this.oldEditedItem.chargeType !== value.chargeType) {
					this.codeLangs.forEach(e => {
						this.policySummary.forEach(ele => {
							if (e === 'vi' && e === ele.lang) {
								ele.description = textCancelVi;
								ele.name = value.nameVi
							} else {
								if(e === ele.lang) {
									ele.description = textCancelDefault;
									ele.name = value.nameVi
								}
							}
						});
					});
					this.editedItem.cancellationI18n = [...this.policySummary];
				}
				this.oldEditedItem = JSON.parse(JSON.stringify(value));
			},
			deep: true
		},
		cancelDaySelect(value) {
			if (value !== -2) {
				this.editedItem.cancellationDay = value;
			}
		},
		cancelRequired(value) {
			if (value === false) {
				this.editedItem.cancellationDay = -1;
				this.cancelDaySelect = -2;
			}
		}
	},
	methods: {
		numberFormat(x, lang) {
			if (x) {
				return new Intl.NumberFormat(this.sysLang, {
					style: 'decimal',
					minimumFractionDigits: lang == 'VND' ? 0 : 2,
					maximumFractionDigits: lang == 'VND' ? 0 : 2,
				}).format(x)
			}
		},
		back() {
			this.$router.back();
		},
		async save() {
			if (!this.editedItem.startStayingDate && this.editedItem.stayingSession ) {
				this.error.startStayingDate.error = true;
			} else {
				this.error.startStayingDate.error = false;
			}

			if (!this.editedItem.endStayingDate && this.editedItem.stayingSession) {
				this.error.endStayingDate.error = true;
			} else {
				this.error.endStayingDate.error = false;
			}

			if (!this.editedItem.startBookingDate && this.editedItem.bookingSession ) {
				this.error.startBookingDate.error = true;
			} else {
				this.error.startBookingDate.error = false;
			}

			if (!this.editedItem.endBookingDate && this.editedItem.bookingSession) {
				this.error.endBookingDate.error = true;
			} else {
				this.error.endBookingDate.error = false;
			}
			
			this.editedItem.cancellationI18n.forEach(item => {
				if (!item.name) {
                    this.policySummary.forEach(ele => {
                        ele.name = this.editedItem.nameVi
                    });
                }
			});

			if (this.error.startStayingDate.error || this.error.endStayingDate.error || this.error.startBookingDate.error || this.error.endBookingDate.error ) {
				this.$store.commit("alert/display", {
					message: this.$t("MISSING_FIELD"),
					error: true,
					success: false
				});
				return false;
			}

			let form_validate = this.$refs.form.validate();
			this.editedItem.amount = this.editedItem.amount ? this.editedItem.amount : 0;
			if (this.editedItem.id && form_validate ) {
				await service.update(this.editedItem).then(res => {
					_alert(res, this.$t(res.data));

					if (res.responseCode != 0) {
					}
				});
			} else if( form_validate ) {

				await service.insert(this.editedItem).then(res => {
					_alert(res, this.$t(res.data), false);
					let vm = this;
					setTimeout(function() {
						vm.$router.push({ name: "listOfCancellations" });
					}, 1000);
					if (res.responseCode != 0) {

					}
				});
			}
		},
		changeRuleAmount() {
			this.editedItem.amount = 0;
		}
	},
	computed: {
        pricePolicy: {
            get: function () {
                return this.convertDecimalViaLocal(this.editedItem.amount);
            },
            set: function (newValue) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                const value = this.setCurrency(newValue);
                this.editedItem.amount = value;
                if (value == this.editedItem.amount) {
                    this.forceRenderKey++;
					this.$nextTick(() => {
						if (this.$refs.pricePolicy && this.editedItem.chargeType == 0) {
							this.$refs.pricePolicy.focus();
						}
					});
                }
                }, this.timeOutChange(newValue));
            }
        },
    }
};
</script>
